import type { HTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

export const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 font-mono text-[10px] font-medium uppercase tracking-wide",
  {
    variants: {
      variant: {
        accent: "bg-studio-accent/15 text-studio-accent",
        neutral: "bg-studio-card text-studio-muted",
        success: "bg-studio-success/15 text-studio-success",
        warning: "bg-studio-warning/15 text-studio-warning",
        danger: "bg-studio-danger/15 text-studio-danger",
      },
    },
    defaultVariants: { variant: "neutral" },
  }
);

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>;

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
